import React from 'react';
import { Check, Circle } from 'lucide-react';
interface Step {
  id: number;
  title: string;
  description?: string;
}
interface StepperUIProps {
  steps: Step[];
  currentStep: number;
  onStepClick?: (stepId: number) => void;
}
export function StepperUI({
  steps,
  currentStep,
  onStepClick
}: StepperUIProps) {
  return <div className="w-full py-4 sm:py-6" data-id="element-258">
      {/* Desktop/Tablet Horizontal Layout */}
      <div className="hidden sm:flex items-center justify-between relative px-4" data-id="element-259">
        {/* Progress Bar Background */}
        <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-full h-1 bg-slate-200 -z-10 rounded-full" data-id="element-260" />

        {/* Active Progress Bar */}
        <div className="absolute left-0 top-1/2 transform -translate-y-1/2 h-1 bg-green-600 transition-all duration-500 ease-out -z-10 rounded-full" style={{
        width: `${(currentStep - 1) / (steps.length - 1) * 100}%`
      }} data-id="element-261" />

        {steps.map(step => {
        const isCompleted = step.id < currentStep;
        const isCurrent = step.id === currentStep;
        const isClickable = onStepClick && step.id <= currentStep;
        return <div key={step.id} className="flex flex-col items-center relative group" data-id="element-262">
              <button onClick={() => isClickable && onStepClick && onStepClick(step.id)} disabled={!isClickable} className={`
                  w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all duration-300 bg-white z-10
                  ${isCompleted ? 'border-green-600 bg-green-600 text-white scale-100' : ''}
                  ${isCurrent ? 'border-primary-600 text-primary-600 ring-4 ring-primary-100 scale-110' : ''}
                  ${!isCompleted && !isCurrent ? 'border-slate-300 text-slate-400' : ''}
                  ${isClickable ? 'cursor-pointer hover:border-green-500 hover:text-green-500' : 'cursor-default'}
                `} aria-label={`Step ${step.id}: ${step.title}`} aria-current={isCurrent ? 'step' : undefined} data-id="element-263">
                {isCompleted ? <Check className="w-6 h-6 animate-scale-in" data-id="element-264" /> : <span className="font-bold text-sm" data-id="element-265">{step.id}</span>}
              </button>

              {/* Step Title Tooltip/Label */}
              <div className="absolute mt-12 text-center w-32 -ml-16 left-1/2 transform -translate-x-1/2 transition-opacity duration-300" data-id="element-266">
                <p className={`text-xs sm:text-sm font-medium transition-colors duration-300 ${isCurrent ? 'text-primary-900 font-bold' : isCompleted ? 'text-green-700' : 'text-slate-400'}`} data-id="element-267">
                  {step.title}
                </p>
              </div>
            </div>;
      })}
      </div>

      {/* Mobile Vertical Layout */}
      <div className="sm:hidden space-y-4 px-2" data-id="element-268">
        {steps.map((step, index) => {
        const isCompleted = step.id < currentStep;
        const isCurrent = step.id === currentStep;
        const isClickable = onStepClick && step.id <= currentStep;
        const isLast = index === steps.length - 1;
        return <div key={step.id} className="relative flex items-start" data-id="element-269">
              {/* Vertical Line */}
              {!isLast && <div className={`absolute left-5 top-10 bottom-0 w-0.5 -ml-px h-full ${isCompleted ? 'bg-green-600' : 'bg-slate-200'}`} style={{
            height: 'calc(100% + 1rem)'
          }} data-id="element-270" />}

              <button onClick={() => isClickable && onStepClick && onStepClick(step.id)} disabled={!isClickable} className={`
                  flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all duration-300 bg-white z-10 mr-4
                  ${isCompleted ? 'border-green-600 bg-green-600 text-white' : ''}
                  ${isCurrent ? 'border-primary-600 text-primary-600 ring-4 ring-primary-100' : ''}
                  ${!isCompleted && !isCurrent ? 'border-slate-300 text-slate-400' : ''}
                `} data-id="element-271">
                {isCompleted ? <Check className="w-5 h-5" data-id="element-272" /> : <span className="font-bold text-sm" data-id="element-273">{step.id}</span>}
              </button>

              <div className="pt-2" data-id="element-274">
                <p className={`text-sm font-medium transition-colors duration-300 ${isCurrent ? 'text-primary-900 font-bold' : isCompleted ? 'text-green-700' : 'text-slate-500'}`} data-id="element-275">
                  {step.title}
                </p>
                {isCurrent && step.description && <p className="text-xs text-slate-500 mt-1 animate-fade-in" data-id="element-276">
                    {step.description}
                  </p>}
              </div>
            </div>;
      })}
      </div>
    </div>;
}